<template>
  <v-map
    :style="defaultStyles"
    :class="defaultClass"
    :maxZoom="options.maxZoom"
    :center="center.icon"
    :options="options.options"
    :bounds="bounds"
    style="z-index: 0; position: relative;"
    ref="map"
  >
    <v-tilelayer :url="options.url" :attribution="options.attribution">
    </v-tilelayer>
    <template v-if="coords.length > 0">
      <slot name="marker" />
    </template>
  </v-map>
</template>

<script>
import * as Vue2Leaflet from "vue2-leaflet";
import Map from "@/components/ui/Map/Map";

export default {
  name: "MapWithBounds",
  extends: Map,
  components: {
    vMap: Vue2Leaflet.LMap,
    vTilelayer: Vue2Leaflet.LTileLayer
  },
  props: {
    bounds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      resizeObserver: null
    };
  },
  mounted() {
    window.dispatchEvent(new Event("resize"));

    this.$nextTick(() => {
      this.sizeMonitor();
    });
  },
  beforeDestroy() {
    this.resizeObserver.disconnect();
  },
  methods: {
    fitBounds() {
      if (this.$refs.map) {
        this.$refs.map.mapObject.fitBounds(this.bounds, { padding: [25, 25] });
      }
    },
    sizeMonitor() {
      this.resizeObserver = new ResizeObserver(() => {
        this.fitBounds();
      });
      this.resizeObserver.observe(this.$refs.map.$el);
    }
  }
};
</script>
